// Conversion factors
const INCH_TO_CM = 2.54;
const LB_TO_KG = 0.453592;

/**
 * Converts inches to centimeters.
 * @param {number|string} inches The value in inches.
 * @returns {number|string} The value in centimeters, or original if input is invalid.
 */
export const inchesToCm = (inches) => {
  const num = parseFloat(inches);
  if (isNaN(num)) return inches; // Return original if not a number
  return num * INCH_TO_CM;
};

/**
 * Converts centimeters to inches.
 * @param {number|string} cm The value in centimeters.
 * @returns {number|string} The value in inches, or original if input is invalid.
 */
export const cmToInches = (cm) => {
  const num = parseFloat(cm);
  if (isNaN(num)) return cm; // Return original if not a number
  return num / INCH_TO_CM;
};

/**
 * Converts pounds to kilograms.
 * @param {number|string} lbs The value in pounds.
 * @returns {number|string} The value in kilograms, or original if input is invalid.
 */
export const lbsToKg = (lbs) => {
  const num = parseFloat(lbs);
  if (isNaN(num)) return lbs; // Return original if not a number
  return num * LB_TO_KG;
};

/**
 * Converts kilograms to pounds.
 * @param {number|string} kg The value in kilograms.
 * @returns {number|string} The value in pounds, or original if input is invalid.
 */
export const kgToLbs = (kg) => {
  const num = parseFloat(kg);
  if (isNaN(num)) return kg; // Return original if not a number
  return num / LB_TO_KG;
};
